export function formatDate(value) {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return value;
  return d.toLocaleDateString(undefined, { year: "numeric", month: "short", day: "2-digit" });
}

// A readable message from an API error; FastAPI validation errors are listed field by field.
export function apiErrorMessage(err, fallback, labels = {}) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const parts = detail.map((d) => {
      const field = Array.isArray(d.loc) ? d.loc.filter((p) => p !== "body").pop() : d.loc;
      return `${labels[field] || field || "unknown field"}: ${d.msg || "invalid value"}`;
    });
    return `Required fields are missing or invalid: ${parts.join("; ")}`;
  }
  return fallback;
}
